import React from 'react';
import './BusinessProfileLoading.css';

export default function BusinessProfileLoading() {
  return <div className="bp-profile-loading" role="status" aria-label="Cargando perfil del negocio" aria-busy="true">
    <span className="bp-loading-message">Preparando el perfil del negocio…</span>
    <div className="bp-loading-layout" aria-hidden="true">
      <div className="bp-loading-hero">
        <div className="bp-loading-mark bp-loading-placeholder" />
        <div className="bp-loading-identity"><div className="bp-loading-name bp-loading-placeholder"/><div className="bp-loading-meta bp-loading-placeholder"/><div className="bp-loading-action bp-loading-placeholder"/></div>
      </div>
      <div className="bp-loading-tabs">{[0,1,2,3].map(key=><span key={key} className="bp-loading-placeholder"/>)}</div>
      <div className="bp-loading-services">{[0,1,2].map(key=><div key={key} className="bp-loading-service"><div className="bp-loading-placeholder"/><div className="bp-loading-placeholder"/><div className="bp-loading-placeholder"/></div>)}</div>
    </div>
  </div>;
}
